import React from 'react';
import { View, ScrollView, StyleSheet, Text, Platform } from 'react-native';
import { Title, Paragraph, IconButton } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default function PrivacyPolicyPage({ onClose }) {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Title style={styles.title}>Gizlilik Politikası</Title>
        <IconButton
          icon={() => <MaterialCommunityIcons name="close" size={24} color="#FFFFFF" />}
          onPress={onClose}
          style={styles.closeButton}
        />
      </View>
      <ScrollView style={styles.content} contentContainerStyle={styles.contentContainer}>
        <Paragraph style={styles.lastUpdated}>
          Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Şamata Play olarak gizliliğinizi önemsiyoruz. Kayıt veya zorunlu kişisel bilgi toplamayız; temel işlevler için sadece teknik ve anonim veriler kullanılır.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>1. Toplanan Bilgiler</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Text style={styles.bold}>1.1. Kişisel bilgi toplanmaz:</Text>
          {'\n'}• Zorunlu isim, e-posta, telefon vb. istemiyoruz.
          {'\n'}• Favoriler ve son dinlenenler cihazınızda yerel olarak saklanır.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Text style={styles.bold}>1.2. Teknik/anonim bilgiler:</Text>
          {'\n'}• Cihaz ve platform bilgisi (web/mobil, OS sürümü)
          {'\n'}• Hata logları ve performans ölçümleri
          {'\n'}• Reklam gösterimi için AdSense’in kendi çerezleri/teknolojileri
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>2. Bilgilerin Kullanımı</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          • Hizmeti çalıştırmak ve iyileştirmek
          {'\n'}• Hata/performans sorunlarını tespit etmek
          {'\n'}• Güvenlik ve kötüye kullanımı önlemek
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>3. Bilgilerin Paylaşılması</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          • Kişisel verileri üçüncü taraflarla paylaşmıyoruz.
          {'\n'}• Yasal zorunluluk ve güvenlik durumları hariç paylaşım yapılmaz.
          {'\n'}• Reklamlar için Google AdSense kendi çerezlerini kullanabilir; biz profil oluşturmayız.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>4. Çerezler ve Takip</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          • Temel işlevler için zorunlu çerezler.
          {'\n'}• Google AdSense reklamları için Google’ın çerezleri/teknolojileri.
          {'\n'}• Tarayıcı ayarlarınızdan çerezleri yönetebilir veya engelleyebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>5. Veri Güvenliği ve Saklama</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          • Endüstri standardı güvenlik önlemleri uygularız.
          {'\n'}• Favoriler/son dinlenenler cihazınızda kalır; sunucuda profil tutmayız.
          {'\n'}• Teknik loglar kısa süreli saklanır, sonra silinir.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>6. Çocukların Gizliliği</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          • 13 yaş altından bilerek veri toplamıyoruz.
          {'\n'}• Fark edilirse ilgili veriler silinir.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>7. Haklar ve İletişim</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Sorularınız veya veri talepleriniz için: info@samataplay.com
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>9. Gizlilik Politikası Değişiklikleri</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler 
          yaptığımızda, uygulama içinde veya e-posta yoluyla sizi bilgilendireceğiz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>10. İletişim</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Gizlilik Politikamız hakkında sorularınız varsa, lütfen bizimle iletişime geçin:
          {'\n'}E-posta: info@samataplay.com
          {'\n'}Web: www.samataplay.com
        </Paragraph>

        <View style={styles.footer}>
          <Paragraph style={styles.footerText}>
            © 2024 Şamata Play. Tüm hakları saklıdır.
          </Paragraph>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: Platform.OS === 'web' ? 20 : 40,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#333333',
  },
  title: {
    color: '#FFFFFF',
    fontSize: 24,
    fontWeight: 'bold',
  },
  closeButton: {
    margin: 0,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    padding: 20,
    paddingBottom: 40,
  },
  lastUpdated: {
    color: '#888888',
    fontSize: 14,
    fontStyle: 'italic',
    marginBottom: 20,
  },
  paragraph: {
    color: '#CCCCCC',
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 20,
  },
  sectionTitle: {
    color: '#FFFFFF',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 10,
  },
  bold: {
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  footer: {
    marginTop: 40,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#333333',
  },
  footerText: {
    color: '#888888',
    fontSize: 14,
    textAlign: 'center',
  },
});

